import { uid } from '../../../../lib/uid';
import type { ProcurementCatalogSlug } from '../procurementCatalogTypes';

/*
  Plausible vocabulary rather than obviously synthetic values, which is the right call here for
  the reason `sampleLearningDevelopmentEntry`'s wordings are: none of these ever leaves `rsys_`
  or lands in the identity store, and an unreadable one would make the generated form worse at
  the one job it has — showing what the field is for. The rule is about where a value LANDS,
  never which generator produced it.
*/
const NAMES: Record<ProcurementCatalogSlug, readonly string[]> = {
  types: ['Goods', 'Infrastructure Projects', 'Consulting Services', 'General Services'],
  modes: [
    'Small Value Procurement',
    'Shopping',
    'Negotiated Procurement',
    'Direct Contracting',
  ],
};

const DESCRIPTIONS: Record<ProcurementCatalogSlug, string> = {
  types: 'Sample procurement type. Delete it once the real vocabulary is in.',
  modes: 'Sample mode of procurement. Delete it once the real vocabulary is in.',
};

/**
 * A sample vocabulary row, so the form fills in one click.
 *
 * **The name is suffixed because it is unique among active rows.** Autogenerate is most useful
 * clicked repeatedly, and the create is idempotent on the name — so without a suffix the second
 * click would quietly return the first row rather than adding one, which reads as the button
 * having stopped working.
 */
export function sampleProcurementCatalogEntry(catalog: ProcurementCatalogSlug): {
  name: string;
  description: string;
} {
  const tag = uid().slice(0, 4).toUpperCase();
  const pool = NAMES[catalog];

  return {
    name: `${pool[Math.floor(Math.random() * pool.length)]} ${tag}`,
    description: DESCRIPTIONS[catalog],
  };
}
